<style lang="scss" scoped>
.app {
	&__container {
		padding: 30px;
		@include sm-and-down {
			padding: 15px;
		}
		@include md-and-up {
			@include flex-top;
		}
	}
	&__logo {
		width: 180px;
		border-radius: 20px;
		display: block;
		background: white;
		margin-right: 60px;
		box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);
		margin-bottom: 20px;
		@include sm-and-down {
			margin: auto;
			width: 100px;
			margin-bottom: 40px;
		}
	}
	&__supports {
		margin-top: 40px;
		h3 {
			@include sm-and-down {
				font-size: 18px;
			}
		}
		strong {
			color: #3d85ff;
		}
		ul {
			// list-style: none;
			margin: 25px 0 0 20px;
			padding: 0;
			li {
				margin-bottom: 15px;
			}
		}
	}
	&__install {
		width: 180px;
		margin-top: 15px;
		@include sm-and-down {
			display: none;
		}
	}
	&__heading {
		font-size: 30px;
		margin-bottom: 10px;
		line-height: 50px;
		@include sm-and-down {
			font-size: 18px;
		}
	}
	&__description {
		margin-top: 0;
	}
}
</style>

<template lang="pug">
    layout-page.app 
        template(slot="breadcrumb")
            router-link(to="/") Discover
            divider
            | {{ $apollo.loading ? "Loading..." : Company.name }}
        panel(v-if="!$apollo.loading")
            .app__container 
                .app__left
                    img(v-bind:src="Company.application_logo").app__logo
                    el-button(type="primary", round, :loading="installing", @click="install").app__install Add application
                .app__right
                    h1.app__heading {{ Company.name }}
                    p.app__description {{ Company.application_description || Company.application_short_description }}
                    .app__supports
                        h3 This application supports:
                        p(v-if="Company.sso_active || Company.sp_enabled") <strong>Single Sign-On</strong> directly into {{ Company.name }} via Wonde
                        p(v-else) <strong>Dashboard link</strong> to quickly launch {{ companyNameBelongsTo }} website from your Wonde dashboard
</template>

<script>
import gql from "graphql-tag";

export default {
	data() {
		return {
			installing: false
		};
	},

	computed: {
		companyNameBelongsTo() {
			if (this.Company.name[this.Company.name.length - 1] === "s") {
				return `${this.Company.name}`;
			} else {
				return `${this.Company.name}'s`;
			}
		}
	},

	apollo: {
		Company: {
			query: gql`
				query GetCompany($slug: String!) {
					Company(slug: $slug) {
						id
						name
						slug
						application_logo
						application_description
						application_short_description
						sso_active
						sp_enabled
					}
				}
			`,
			variables() {
				return {
					slug: this.$route.params.slug
				};
			}
		}
	},

	methods: {
		install() {
			this.installing = true;
			window.open(`${process.env.VUE_APP_EDU_WONDE_DOMAIN}install/${this.Company.slug}`);
			this.installing = false;
		}
	}
};
</script>
